import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy/page'));

const ContactPage = lazy(() => import('../pages/contact/page'));
const ReturnPolicyPage = lazy(() => import('../pages/return-policy/page'));
const PaymentPolicyPage = lazy(() => import('../pages/payment-policy/page'));
const DeleteAccountPage = lazy(() => import('../pages/delete-account/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '/return-policy',
    element: <ReturnPolicyPage />
  },
  {
    path: '/payment-policy',
    element: <PaymentPolicyPage />
  },
  {
    path: '/delete-account',
    element: <DeleteAccountPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;